var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.5 20h-2.5a1 1 0 0 1 0-2h2.5a.50641.50641 0 0 0 .5-.5v-14a.50641.50641 0 0 0 -.5-.5h-12a.50641.50641 0 0 0 -.5.5v2.5a1 1 0 0 1 -2 0v-2.5a2.50263 2.50263 0 0 1 2.5-2.5h12a2.50263 2.50263 0 0 1 2.5 2.5v14a2.50263 2.50263 0 0 1 -2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5 23h-11a2.50263 2.50263 0 0 1 -2.5-2.5v-13a2.50263 2.50263 0 0 1 2.5-2.5h11a2.50263 2.50263 0 0 1 2.5 2.5v13a2.50263 2.50263 0 0 1 -2.5 2.5zm-11-16a.50065.50065 0 0 0 -.5.5v13a.50065.50065 0 0 0 .5.5h11a.50065.50065 0 0 0 .5-.5v-13a.50065.50065 0 0 0 -.5-.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e6893ba6a4a37d2e86e65a91315f065c.svg";
export { ForwardRef as ReactComponent };